import React, { Component } from 'react';
import _ from 'lodash';
import { GenericInput, CheckBox, Button, Text, Popup } from '../../components';
import { COLOUR_GREEN, COLOUR_RED } from '../../js';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { checkLoggedIn, validateAccess } from '../../session';
import { userActions } from '../../webapi';
import FontAwesome from 'react-fontawesome';
import { Table } from 'react-bootstrap';
import moment from 'moment';
import { getPluralS } from '../../helper';

class WelcomeEmails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      welcomeStatus: [],
      selectedUsers: [],
      loading: false,
      submitting: false,
      success: false,
      search: '',
      startIndex: 0,
      endIndex: 100,
      cancelSending: false,
      skippedCount: 0,
    };
  }

  UNSAFE_componentWillMount() {
    checkLoggedIn(this, this.props.auth);
  }

  componentDidMount() {
    if (!validateAccess(this.props.auth.site, 'userManagement', this.props.auth, true)) {
      this.props.history.push('/mastermenu');
    } else {
      this.getWelcomeStatus();
    }
  }

  getWelcomeStatus = () => {
    this.setState({ loading: true }, async () => {
      try {
        // chunk users into sizeable calls
        const usersToFetch = this.props.users
          .map((user) => user.userId)
          .filter((userId) => {
            return !_.some(this.state.welcomeStatus, { userId });
          })
          .slice(0, 100);

        if (_.isEmpty(usersToFetch)) {
          this.setState({ loading: false });
          return;
        }
        // get welcome status for chunk
        const { data } = await userActions.getWelcomeStatus(this.props.auth.site, usersToFetch);
        // call again on success until all users are done
        this.setState({ welcomeStatus: [...this.state.welcomeStatus, ...data] }, () => {
          this.getWelcomeStatus();
        });
      } catch (error) {
        console.log('getWelcomeStatus - error', error);
      } finally {
        this.setState({ loading: false });
      }
    });
  };

  prevPage = () => {
    if (this.state.startIndex === 0) {
      return;
    }
    this.setState({
      startIndex: this.state.startIndex - 100,
      endIndex: Math.ceil(this.state.endIndex / 100) * 100 - 100,
    });
  };

  nextPage = () => {
    if (this.state.startIndex + 100 >= this.props.users.length) {
      return;
    }
    this.setState({
      startIndex: this.state.startIndex + 100,
      endIndex: Math.ceil(this.state.endIndex / 100) * 100 + 100,
    });
  };

  getPaginationText() {
    const source = this.getSource();
    return `${Math.min(this.state.startIndex + 1, source.length)}-${Math.min(this.state.endIndex, source.length)}/${source.length}`;
  }

  getSource(paginated) {
    const { search } = this.state;
    let source = this.props.users;

    if (!_.isEmpty(search)) {
      let lowSearch = search.toLowerCase();
      if (lowSearch.indexOf('04') === 0) {
        lowSearch = lowSearch.substring(1); // account for phone numbers stored in +61 format
      }
      source = _.filter(source, (ev) => {
        if (!ev.displayName) {
          return false;
        }
        return (
          ev.displayName.toLowerCase().indexOf(lowSearch) > -1 ||
          (!_.isEmpty(ev.email) && ev.email.toLowerCase().indexOf(lowSearch) > -1) ||
          (!_.isEmpty(ev.phoneNumber) && ev.phoneNumber.toLowerCase().indexOf(lowSearch) > -1)
        );
      });
    }
    source = _.sortBy(source, (user) => {
      return (user.displayName || '').toLowerCase();
    });
    if (paginated) {
      return source.slice(this.state.startIndex, this.state.endIndex);
    }
    return source;
  }

  toggleSelectUser = (userId) => {
    const { selectedUsers } = this.state;
    if (selectedUsers.includes(userId)) {
      this.setState({ selectedUsers: selectedUsers.filter((id) => id !== userId) });
    } else {
      this.setState({ selectedUsers: [...selectedUsers, userId] });
    }
  };

  toggleSelectAll = () => {
    const { selectedUsers } = this.state;
    const allUserIds = this.props.users.map((user) => user.userId);
    const isAllSelected =
      allUserIds.length > 0 && allUserIds.every((userId) => selectedUsers.includes(userId)) && selectedUsers.length === allUserIds.length;
    if (isAllSelected) {
      this.setState({ selectedUsers: [] });
    } else {
      this.setState({ selectedUsers: allUserIds });
    }
  };

  toggleSelectAllNotOnboarded = () => {
    const { selectedUsers } = this.state;
    const allUserIds = this.props.users.filter((user) => !user.onBoardingSeen).map((user) => user.userId);
    const isAllSelected =
      allUserIds.length > 0 && allUserIds.every((userId) => selectedUsers.includes(userId)) && selectedUsers.length === allUserIds.length;
    if (isAllSelected) {
      this.setState({ selectedUsers: [] });
    } else {
      this.setState({ selectedUsers: allUserIds });
    }
  };

  toggleSelectAllNotInvited = () => {
    const { selectedUsers } = this.state;
    const allUserIds = this.props.users
      .filter((user) => {
        // Only include users with email addresses
        if (!user.email || _.isEmpty(user.email)) {
          return false;
        }
        const welcomeStatus = _.find(this.state.welcomeStatus, { userId: user.userId });
        return (
          !welcomeStatus || !welcomeStatus.WelcomeStatus || !welcomeStatus.WelcomeStatus.Email || !welcomeStatus.WelcomeStatus.Email.Success
        );
      })
      .map((user) => user.userId);
    const isAllSelected =
      allUserIds.length > 0 && allUserIds.every((userId) => selectedUsers.includes(userId)) && selectedUsers.length === allUserIds.length;
    if (isAllSelected) {
      this.setState({ selectedUsers: [] });
    } else {
      this.setState({ selectedUsers: allUserIds });
    }
  };

  toggleSelectAllNotInvitedViaText = () => {
    const { selectedUsers } = this.state;
    const allUserIds = this.props.users
      .filter((user) => {
        // Only include users with phone numbers
        if (!user.phoneNumber || _.isEmpty(user.phoneNumber)) {
          return false;
        }
        const welcomeStatus = _.find(this.state.welcomeStatus, { userId: user.userId });
        return (
          !welcomeStatus || !welcomeStatus.WelcomeStatus || !welcomeStatus.WelcomeStatus.Text || !welcomeStatus.WelcomeStatus.Text.Success
        );
      })
      .map((user) => user.userId);
    const isAllSelected =
      allUserIds.length > 0 && allUserIds.every((userId) => selectedUsers.includes(userId)) && selectedUsers.length === allUserIds.length;
    if (isAllSelected) {
      this.setState({ selectedUsers: [] });
    } else {
      this.setState({ selectedUsers: allUserIds });
    }
  };

  sendEmails = () => {
    const { selectedUsers } = this.state;
    if (selectedUsers.length > 0) {
      this.setState(
        {
          submitting: true,
          sendType: 'email',
          toSendCount: selectedUsers.length,
          sentCount: 0,
          errorCount: 0,
          skippedCount: 0,
          cancelSending: false,
        },
        () => {
          this.sendNextEmail(selectedUsers, 0);
        },
      );
    }
  };

  sendTexts = () => {
    const { selectedUsers } = this.state;
    if (selectedUsers.length > 0) {
      this.setState(
        {
          submitting: true,
          sendType: 'text',
          toSendCount: selectedUsers.length,
          sentCount: 0,
          errorCount: 0,
          skippedCount: 0,
          cancelSending: false,
        },
        () => {
          this.sendNextText(selectedUsers, 0);
        },
      );
    }
  };

  sendNextEmail = (userIds, index) => {
    if (index >= userIds.length || this.state.cancelSending) {
      this.setState({ submitting: false, success: !this.state.cancelSending });
      return;
    }
    const userId = userIds[index];
    const user = this.props.users.find((u) => u.userId === userId);

    // Check if user has email
    if (!user || !user.email || _.isEmpty(user.email)) {
      console.log('sendWelcomeEmail - user has no email', userId);
      this.setState((prevState) => ({
        skippedCount: prevState.skippedCount + 1,
        sentCount: prevState.sentCount + 1,
      }));
      this.sendNextEmail(userIds, index + 1);
      return;
    }

    userActions
      .sendWelcomeEmail(this.props.auth.site, userId)
      .then((res) => {
        if (this.state.cancelSending) return;
        
        // Check if the response indicates success
        const isSuccess = res && res.data && res.data.WelcomeStatus && res.data.WelcomeStatus.Email && res.data.WelcomeStatus.Email.Success === true;
        
        this.setState((prevState) => {
          const welcomeStatus = _.find(this.state.welcomeStatus, { userId });
          if (welcomeStatus) {
            if (!welcomeStatus.WelcomeStatus) {
              welcomeStatus.WelcomeStatus = {};
            }
            welcomeStatus.WelcomeStatus.Email = res.data.WelcomeStatus.Email;
          }
          
          // Only count as error if Success is false
          const newState = {
            welcomeStatus: [...this.state.welcomeStatus],
            sentCount: prevState.sentCount + 1,
          };
          
          if (!isSuccess) {
            console.log('sendWelcomeEmail - API returned Success: false', userId, res.data);
            newState.errorCount = prevState.errorCount + 1;
          }
          
          return newState;
        });
        this.sendNextEmail(userIds, index + 1);
      })
      .catch((error) => {
        console.log('sendWelcomeEmail - error', error);
        this.setState((prevState) => ({
          errorCount: prevState.errorCount + 1,
          sentCount: prevState.sentCount + 1,
        }));
        this.sendNextEmail(userIds, index + 1);
      });
  };

  sendNextText = (userIds, index) => {
    if (index >= userIds.length || this.state.cancelSending) {
      this.setState({ submitting: false, success: !this.state.cancelSending });
      return;
    }
    const userId = userIds[index];
    const user = this.props.users.find((u) => u.userId === userId);

    // Check if user has phone number
    if (!user || !user.phoneNumber || _.isEmpty(user.phoneNumber)) {
      console.log('sendWelcomeText - user has no phone number', userId);
      this.setState((prevState) => ({
        skippedCount: prevState.skippedCount + 1,
        sentCount: prevState.sentCount + 1,
      }));
      this.sendNextText(userIds, index + 1);
      return;
    }

    userActions
      .sendWelcomeText(this.props.auth.site, userId)
      .then((res) => {
        if (this.state.cancelSending) return;
        
        // Check if the response indicates success
        const isSuccess = res && res.data && res.data.WelcomeStatus && res.data.WelcomeStatus.Text && res.data.WelcomeStatus.Text.Success === true;
        
        this.setState((prevState) => {
          const welcomeStatus = _.find(this.state.welcomeStatus, { userId });
          if (welcomeStatus) {
            if (!welcomeStatus.WelcomeStatus) {
              welcomeStatus.WelcomeStatus = {};
            }
            welcomeStatus.WelcomeStatus.Text = res.data.WelcomeStatus.Text;
          }
          
          // Only count as error if Success is false
          const newState = {
            welcomeStatus: [...this.state.welcomeStatus],
            sentCount: prevState.sentCount + 1,
          };
          
          if (!isSuccess) {
            console.log('sendWelcomeText - API returned Success: false', userId, res.data);
            newState.errorCount = prevState.errorCount + 1;
          }
          
          return newState;
        });
        this.sendNextText(userIds, index + 1);
      })
      .catch((error) => {
        console.log('sendWelcomeText - error', error);
        this.setState((prevState) => ({
          errorCount: prevState.errorCount + 1,
          sentCount: prevState.sentCount + 1,
        }));
        this.sendNextText(userIds, index + 1);
      });
  };

  closePopup = () => {
    this.setState({
      submitting: false,
      success: false,
      sentCount: 0,
      errorCount: 0,
      skippedCount: 0,
      toSendCount: 0,
      sendType: null,
      cancelSending: false,
    });
  };

  cancelSending = () => {
    this.setState({ cancelSending: true });
  };

  renderSearch() {
    return (
      <div className="flex flex-center marginBottom-20">
        <Text type="h5" className="marginRight-20">
          Filter by
        </Text>
        <GenericInput
          id={`search`}
          type="text"
          placeholder="Search users"
          value={this.state.search}
          onChange={(e) => this.setState({ search: e.target.value })}
          autoComplete={false}
          className="genericInputContainer-rounded"
          style={{ width: 400, marginBottom: 0 }}
        />
      </div>
    );
  }

  renderPagination() {
    return (
      <div className="paginationContainer">
        <FontAwesome className="pagination__left" name="chevron-left" onClick={this.prevPage} />
        <p className="pagination__text">{this.getPaginationText()}</p>
        <FontAwesome className="pagination__right" name="chevron-right" onClick={this.nextPage} />
      </div>
    );
  }

  renderWelcomeStatus(userId, type) {
    const welcomeStatus = _.find(this.state.welcomeStatus, { userId });
    if (!welcomeStatus || !welcomeStatus.WelcomeStatus) {
      return <span />;
    }
    const status = welcomeStatus.WelcomeStatus[type];
    if (!status) {
      return <span />;
    }
    //status object is: { Success: true, Timestamp: 1679312255288, Value: 'example@test.com' }
    const { Success, Timestamp, Value } = status;
    const date = moment.utc(Timestamp).local().format('D MMM YYYY');
    const time = moment.utc(Timestamp).local().format('h:mm A');
    const statusText = Success ? 'Sent' : 'Failed';
    const statusColour = Success ? COLOUR_GREEN : COLOUR_RED;
    const statusIcon = Success ? (
      <FontAwesome name="check" style={{ color: statusColour }} />
    ) : (
      <FontAwesome name="times" style={{ color: statusColour }} />
    );

    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {statusIcon}
          <span style={{ marginLeft: 5, color: statusColour }}>{statusText}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ fontSize: 12 }}>
            {Value}
            <br />
            {date} {time}
          </span>
        </div>
      </div>
    );
  }

  renderAcceptedTerms(user) {
    // render check or x like welcome status
    const hasAccepted = user.onBoardingSeen;
    const statusIcon = hasAccepted ? (
      <FontAwesome name="check" style={{ color: COLOUR_GREEN }} />
    ) : (
      <FontAwesome name="times" style={{ color: COLOUR_RED }} />
    );
    const statusText = hasAccepted ? 'Yes' : 'No';
    const statusColour = hasAccepted ? COLOUR_GREEN : COLOUR_RED;

    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {statusIcon}
          <span style={{ marginLeft: 5, color: statusColour }}>{statusText}</span>
        </div>
        {user.onBoardingSeenTime && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: 12 }}>
              {user.onBoardingSeenTime && moment.utc(user.onBoardingSeenTime).local().format('D MMM YYYY')}
            </span>
          </div>
        )}
        {user.termsVersionAccepted && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: 12 }}>
              Version accepted:
              <br />
              {user.termsVersionAccepted}
            </span>
          </div>
        )}
      </div>
    );
  }

  renderCheckbox(user) {
    const isChecked = this.state.selectedUsers.includes(user.userId);
    return <CheckBox className="checkbox" isActive={isChecked} onChange={() => this.toggleSelectUser(user.userId)} />;
  }

  renderUsers(source) {
    return source.map((user, index) => {
      return (
        <tr key={index}>
          <td>{this.renderCheckbox(user)}</td>
          <td>{user.displayName}</td>
          <td>{user.email}</td>
          <td>{user.phoneNumber}</td>
          <td>{this.renderAcceptedTerms(user)}</td>
          <td>{this.renderWelcomeStatus(user.userId, 'Email')}</td>
          <td>{this.renderWelcomeStatus(user.userId, 'Text')}</td>
        </tr>
      );
    });
  }

  renderTable() {
    const source = this.getSource(true);
    return (
      <>
        <div className="flex flex-between" style={{ alignItems: 'flex-start' }}>
          <div>
            <CheckBox
              isActive={(() => {
                const allUserIds = this.props.users.map((user) => user.userId);
                return (
                  allUserIds.length > 0 &&
                  allUserIds.every((userId) => this.state.selectedUsers.includes(userId)) &&
                  this.state.selectedUsers.length === allUserIds.length
                );
              })()}
              onChange={this.toggleSelectAll}
              label="Select All"
            />
            <CheckBox
              isActive={(() => {
                const notOnboardedUserIds = this.props.users.filter((user) => !user.onBoardingSeen).map((user) => user.userId);
                return (
                  notOnboardedUserIds.length > 0 &&
                  notOnboardedUserIds.every((userId) => this.state.selectedUsers.includes(userId)) &&
                  this.state.selectedUsers.length === notOnboardedUserIds.length
                );
              })()}
              onChange={this.toggleSelectAllNotOnboarded}
              label="Select All Not Accepted Terms"
            />
            <CheckBox
              isActive={(() => {
                const notInvitedEmailUsers = this.props.users
                  .filter((user) => {
                    // Only include users with email addresses
                    if (!user.email || _.isEmpty(user.email)) {
                      return false;
                    }
                    const welcomeStatus = _.find(this.state.welcomeStatus, { userId: user.userId });
                    return (
                      !welcomeStatus ||
                      !welcomeStatus.WelcomeStatus ||
                      !welcomeStatus.WelcomeStatus.Email ||
                      !welcomeStatus.WelcomeStatus.Email.Success
                    );
                  })
                  .map((user) => user.userId);

                return (
                  notInvitedEmailUsers.length > 0 &&
                  notInvitedEmailUsers.every((userId) => this.state.selectedUsers.includes(userId)) &&
                  this.state.selectedUsers.length === notInvitedEmailUsers.length
                );
              })()}
              onChange={this.toggleSelectAllNotInvited}
              label="Select All Not Invited via Email"
            />
            <CheckBox
              isActive={(() => {
                const notInvitedTextUsers = this.props.users
                  .filter((user) => {
                    // Only include users with phone numbers
                    if (!user.phoneNumber || _.isEmpty(user.phoneNumber)) {
                      return false;
                    }
                    const welcomeStatus = _.find(this.state.welcomeStatus, { userId: user.userId });
                    return (
                      !welcomeStatus ||
                      !welcomeStatus.WelcomeStatus ||
                      !welcomeStatus.WelcomeStatus.Text ||
                      !welcomeStatus.WelcomeStatus.Text.Success
                    );
                  })
                  .map((user) => user.userId);

                return (
                  notInvitedTextUsers.length > 0 &&
                  notInvitedTextUsers.every((userId) => this.state.selectedUsers.includes(userId)) &&
                  this.state.selectedUsers.length === notInvitedTextUsers.length
                );
              })()}
              onChange={this.toggleSelectAllNotInvitedViaText}
              label="Select All Not Invited via Text"
            />
          </div>
          <div className="flex flex-end flex-column">
            <div className="userTypesButtonContainer userTypesButtonContainer-noTop">
              <Button
                inline
                buttonType="primaryAction"
                onClick={this.sendTexts}
                isActive={this.state.selectedUsers.length > 0}
                style={{ marginBottom: 10 }}
              >
                <div className="buttonInner">
                  <FontAwesome name="comment" style={{ fontSize: 19 }} />
                  <div className="text">
                    Send Welcome Text to {this.state.selectedUsers.length} User{getPluralS(this.state.selectedUsers.length)}
                  </div>
                </div>
              </Button>
            </div>
            <div className="userTypesButtonContainer userTypesButtonContainer-noTop">
              <Button inline buttonType="primaryAction" onClick={this.sendEmails} isActive={this.state.selectedUsers.length > 0}>
                <div className="buttonInner">
                  <FontAwesome name="envelope" style={{ fontSize: 19 }} />
                  <div className="text">
                    Send Welcome Email to {this.state.selectedUsers.length} User{getPluralS(this.state.selectedUsers.length)}
                  </div>
                </div>
              </Button>
            </div>
          </div>
        </div>
        <Table className="plussTable" striped bordered condensed hover style={{ minWidth: '100%' }}>
          <thead>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Accepted Terms?</th>
              <th>Welcome Email Status</th>
              <th>Welcome Text Status</th>
            </tr>
          </thead>
          <tbody>{this.renderUsers(source)}</tbody>
        </Table>
      </>
    );
  }

  renderSendingPopup() {
    const { submitting, success, sentCount, errorCount, skippedCount, toSendCount, sendType, cancelSending } = this.state;
    if (!submitting && !success) {
      return null;
    }
    const messageType = sendType === 'text' ? 'Text' : 'Email';
    const messageTypePlural = sendType === 'text' ? 'texts' : 'emails';
    const contactType = sendType === 'text' ? 'phone number' : 'email address';

    let buttons = [];
    if (success || cancelSending) {
      buttons = [
        {
          type: 'primary',
          onClick: this.closePopup,
          isActive: true,
          text: 'Done',
        },
      ];
    } else if (submitting && !cancelSending) {
      buttons = [
        {
          type: 'secondary',
          onClick: this.cancelSending,
          isActive: true,
          text: 'Cancel',
        },
      ];
    }

    return (
      <Popup
        title={`Sending ${toSendCount} Welcome ${messageType}${getPluralS(toSendCount)}`}
        hasPadding
        minWidth={500}
        maxWidth={500}
        buttons={buttons}
      >
        <div className="flex flex-center marginTop-20">
          <Text type="h4" className="marginRight-20">
            {cancelSending
              ? `Cancelled. Processed ${sentCount} of ${toSendCount} ${messageTypePlural}`
              : `Processed ${sentCount} of ${toSendCount} ${messageTypePlural}`}
          </Text>
        </div>
        <div className="p_progressBar">
          <div
            className="p_progressBar__fill"
            style={{
              transform: `translateX(${(sentCount / toSendCount) * 100 - 100}%)`,
            }}
          />
        </div>

        {/* Show breakdown of results */}
        <div className="marginTop-20">
          {sentCount - errorCount - skippedCount > 0 && (
            <div className="flex flex-center marginBottom-10">
              <FontAwesome name="check" style={{ color: COLOUR_GREEN, width: 20 }} />
              <Text type="h4" className="marginLeft-10">
                {sentCount - errorCount - skippedCount} {messageTypePlural} sent successfully
              </Text>
            </div>
          )}

          {skippedCount > 0 && (
            <div className="flex flex-center marginBottom-10">
              <FontAwesome name="info-circle" style={{ color: '#FFA500', width: 20 }} />
              <Text type="h4" className="marginLeft-10">
                {skippedCount} user{getPluralS(skippedCount)} skipped (no {contactType})
              </Text>
            </div>
          )}

          {errorCount > 0 && (
            <div className="flex flex-center marginBottom-10">
              <FontAwesome name="exclamation-triangle" style={{ color: COLOUR_RED, width: 20 }} />
              <Text type="h4" className="marginLeft-10">
                {errorCount} {messageTypePlural} failed to send
              </Text>
            </div>
          )}
        </div>

        <Text type="helpLarge" className="marginTop-20">
          {cancelSending
            ? `Process cancelled. ${sentCount - skippedCount} ${messageTypePlural} were processed before cancellation.`
            : `Please leave this page open until all ${messageTypePlural} have been sent. You can cancel the process using the button below.`}
        </Text>
      </Popup>
    );
  }

  render() {
    return (
      <div style={{ minWidth: '100%' }}>
        <Text type="h3">Send Invites</Text>
        <div style={{ paddingTop: 24, paddingBottom: 24 }}>
          {this.renderSearch()}
          {this.renderPagination()}
          {this.renderTable()}
          {this.renderSendingPopup()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return { auth };
};

export default connect(mapStateToProps, {})(withRouter(WelcomeEmails));
